import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { CSS_CLASS_PREFIX } from "../constants/css";
import { formatCurrency } from "../lib/formatData";
import styled from "styled-components";
import { cssMainSelector } from "../lib/cssSelectors";

const Container = styled.span`
  ${p => cssMainSelector(p.theme.tdsId)} {
    white-space: nowrap;
  }
`;

class Currency extends PureComponent {
  render() {
    return (
      <Container className={`${CSS_CLASS_PREFIX}-currency`}>
        {this.formattedCurrency()}
      </Container>
    );
  }

  formattedCurrency() {
    const { amount, portal, replaceZeros } = this.props;

    const formattedCurrency = formatCurrency(amount, {
      currencySymbolInFront: portal.currencySymbolInFront,
      decimalSeparator: portal.decimalSeparator,
      decimalZerosReplacement: portal.decimalZerosReplacement,
      replaceZeros: replaceZeros,
      unicodeCurrencySymbol: portal.unicodeCurrencySymbol
    });

    if (formattedCurrency.currencySymbolInFront) {
      return (
        <span>
          <span className={`${CSS_CLASS_PREFIX}-currency-symbol`}>
            {formattedCurrency.unit}
          </span>{" "}
          <span className={`${CSS_CLASS_PREFIX}-currency-main-amount`}>
            {formattedCurrency.mainAmount}
          </span>
          <span className={`${CSS_CLASS_PREFIX}-currency-trail-amount`}>
            {formattedCurrency.trialAmount}
          </span>
        </span>
      );
    } else {
      return (
        <span>
          <span className={`${CSS_CLASS_PREFIX}-currency-main-amount`}>
            {formattedCurrency.mainAmount}
          </span>
          <span className={`${CSS_CLASS_PREFIX}-currency-trail-amount`}>
            {formattedCurrency.trialAmount}
          </span>{" "}
          <span className={`${CSS_CLASS_PREFIX}-currency-symbol`}>
            {formattedCurrency.unit}
          </span>
        </span>
      );
    }
  }
}

Currency.propTypes = {
  amount: PropTypes.number.isRequired,
  portal: PropTypes.object.isRequired,
  replaceZeros: PropTypes.bool
};

Currency.defaultProps = {
  replaceZeros: false
};

export default Currency;
